import EnterpriseDetailInfo from '@/types/enterprise-detail-info';
import { Account } from '@/types/planning';

export const getConquestAppUrl = (enterprise?: EnterpriseDetailInfo) => enterprise?.planningSoftware?.CONQUEST?.returnUrl;

export const filterImportedAccounts = (accounts: Account[]) => accounts.filter((account: Account) => account.imported);

export const filterValidAccounts = (accounts: Account[]) => accounts.filter((account: Account) => account.riskProfile);
